import { ISvgComponent } from '../../svg.models';
import * as S from '../svg.style';

export const ArrowRight: React.FC<ISvgComponent> = ({
  color,
  height,
  width,
  shrinkable,
  ...rest
}) => (
  <S.Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    shrinkable={shrinkable}
    {...rest}
  >
    <path stroke={color} strokeLinecap="round" d="m12.875 20.5 8.5-8.5m0 0-8.5-8.5m8.5 8.5H2.625" />
  </S.Svg>
);

